import {useEffect} from 'react';

import {SiteFooter} from '../components/SiteFooter';
import {SiteHeader} from '../components/SiteHeader';
import {StoryCard} from '../components/StoryCard';
import {articlesInSection, type Section} from '../data/sections';
import {useStoreState} from '../stores/useStoreState';
import type {Article} from '../types/article';

interface SectionPageProps {
  section: Section;
}

export const SectionPage = ({section}: SectionPageProps) => {
  const liveArticles = useStoreState<Article[]>('homepage.liveArticles', []);
  const feedStatus = useStoreState<'error' | 'live' | 'loading'>('homepage.status', 'loading');
  const sectionArticles = articlesInSection(liveArticles, section.label);

  useEffect(() => {
    const previousTitle = document.title;
    document.title = `${section.label} | Chicago Sentinel Times`;
    return () => { document.title = previousTitle; };
  }, [section.label]);

  const emptyMessage = feedStatus === 'error'
    ? 'The article service is temporarily unavailable.'
    : feedStatus === 'loading'
      ? `Loading ${section.label} articles…`
      : `No articles have been published in ${section.label} yet.`;

  return (
    <div className="newspaper">
      <SiteHeader />
      <main className="section-page shell" id="main-content">
        <header className="section-page__header">
          <span className="eyebrow">Section</span>
          <h1>{section.label}</h1>
          <p>Latest articles filed by the Chicago Sentinel Times and its attributed sources.</p>
        </header>
        {sectionArticles.length ? (
          <div className="section-page__grid">
            {sectionArticles.map((article) => <StoryCard article={article} key={article.id} />)}
          </div>
        ) : <p className="section-page__empty" aria-live="polite">{emptyMessage}</p>}
      </main>
      <SiteFooter />
    </div>
  );
};
